import { render } from "./TheG01ContentPoint.vue?vue&type=template&id=1f4311b4&scoped=true&ts=true"
import script from "./TheG01ContentPoint.vue?vue&type=script&lang=ts"
export * from "./TheG01ContentPoint.vue?vue&type=script&lang=ts"

import "./TheG01ContentPoint.vue?vue&type=style&index=0&id=1f4311b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4311b4"]])

export default __exports__